export default "__VITE_ASSET__C4EvJjS0__"